module.exports = __webpack_public_path__ + "static/media/a31.74a29053.jpg";